import { useEffect, useState } from 'react';
import Head from "next/head";
import Script from 'next/script'
import {configuratorHost } from '@/lib/utils.js'


export default function ProductPageConfigurator({product, sku_part_query, 
  always_show_description, all_descriptions_toggle, descriptions_toggle_defaults_to_show}) {
 const [configHTML, setConfigHTML] = useState('');
 const show_desc = always_show_description ? true : false  
 const show_all_toggle = all_descriptions_toggle ? true : false 
 const default_to_show  = descriptions_toggle_defaults_to_show ? true : false 


 useEffect(() => {
 if (typeof window != 'undefined') {
   let queryStr = `?always_show_description=${show_desc}&all_descriptions_toggle=${show_all_toggle}&descriptions_toggle_defaults_to_show=${default_to_show}`
   if (sku_part_query) {
     queryStr += `&sku_parts=${encodeURIComponent(sku_part_query)}`
   }
  fetch(`/lex-api/configurator/${product.id}${queryStr}`, 
    ).then(r => {
      return r.text() })
     .then(html => { 
        setConfigHTML(html)
     })
   }
  }, [product.id])

 return (
   <>
     <Head>
       <link key={'configurator-styles'} rel='stylesheet' href={`${configuratorHost()}/configurator_styles.css`}/>
       
     </Head>
<Script key={'configurator-js'} src={`${configuratorHost()}/configurator_app.js`} 
       strategy='beforeInteractive'> </Script>
   <div id='lexcms-product-configurator-container' className='lexcms-product-section-container'  > 
     <h3 className="lexcms-product-section-heading"> Configure </h3>
     {configHTML &&
     <div id='lex-cms-configurator-app' dangerouslySetInnerHTML={{ __html: configHTML }} />
     }
   </div>
   </>
   )
}
